import { Component } from '@angular/core'

@Component({
  selector: '[app-select-menu-list-divider-item]',
  template: `
       <hr/>
    `,
  styles: '',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SelectMenuListDividerComponent{}
